export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-18.30ea628b.png";